import styled, { keyframes, css } from 'styled-components';
import { layout } from 'src/components/base';

const skeletonKeyframes = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

type Spacing = Extract<keyof typeof layout.measurements, `spacing${any}`>;

export interface SkeletonFrameProps {
  flex?: boolean;
  marginBottom?: Spacing;
  width?: string;
  height?: string;
}

export const SkeletonFrame = styled.span<SkeletonFrameProps>`
  background-color: ${({ theme }) => theme.colors.base0};
  background-image: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.base0},
    ${({ theme }) => theme.colors.base100},
    ${({ theme }) => theme.colors.base0}
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
  line-height: 1;
  width: ${p => p.width ?? '100%'};
  height: ${p => p.height ?? '1em'};
  animation: ${skeletonKeyframes} 1.2s ease-in-out infinite;
  display: inline-block;
  ${p =>
    p.marginBottom && `margin-bottom: ${layout.measurements[p.marginBottom]};`}
  ${p =>
    p.flex &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}

  @media (prefers-reduced-motion) {
    animation: none;
  }
`;
